<div class="global">
  <p *ngIf="widgetConfig?.dataSource" [innerHTML]="widgetConfig?.dataSource[currentLang]"></p>
  <button mat-dialog-close mat-button><mat-icon>close</mat-icon></button>
</div>
